module.exports = __webpack_public_path__ + "img/1-2.74509778.svg";